export default __webpack_public_path__ + "static/media/ser4.dae63650.svg";